import React from 'react';
import Layout from '../components/Layout';
import Contact from '../components/Contact';

function ContactUs() {
  return (
    <Layout>
      <Contact />
    </Layout>
  );
}

export default ContactUs;
